import http from 'plugins/axios'

export default {
  getFundRecordList(data) {
    return http.get({
      url: `/ta/admin/tenant/fund-rate-record/list`,
      data,
    })
  },
  getFundDetailList(data) {
    return http.get({
      url: `/ta/admin/tenant/fund-rate-record/detail-list`,
      data,
    })
  },
  exportFundDetailList(data) {
    return http.get({
      url: `/ta/admin/tenant/fund-rate-record/detail-list/excel`,
      data,
      responseType: 'blob',
    })
  },
  getSymbolList() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',
      data: { type: 'CONTRACT' },
    })
  },
}
